var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"badge text-white",class:_vm.variant},[_vm._v("\n        "+_vm._s(_vm.status)+"\n    ")]),_c('i',{staticClass:"pl-2",class:_vm.getClass,staticStyle:{"font-size":"1.15rem"},attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }